<template>
    <div class="verifyPhone flex-column align-center">
        <img class="verifyPhone-img" src="@/assets/images/user/verify-phone.png" alt="" />
        <p class="verifyPhone-phoneNumber">{{ parsePhoneToStar(userInfo.phoneNo) }}</p>
        <p class="font28" style="color: #999999">实名认证前请先进行手机验证</p>
        <div class="verifyPhone-getCode-btn">
            <van-button class="comfirm-btn" @click="getCode">获取验证码</van-button>
        </div>
    </div>
</template>

<script>
import { parsePhoneToStar, parseSmsKey } from "@/libs/parseData";
import { sendSmsApi } from "@/api/index";
import config from "@/config/index";
export default {
    name: "VerifyPhone",
    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem("userInfo")),
        };
    },
    mounted() {},
    methods: {
        parsePhoneToStar,
        getCode() {
            let params = {
                accessKey: config.accessKey,
                accessToken: parseSmsKey(this.userInfo.phoneNo),
                phoneNo: this.userInfo.phoneNo,
            };
            sendSmsApi(params).then((res) => {
                this.$notify({
                    message: "验证码已发送，请注意查收",
                    color: "#009AF3",
                    background: "#D3E8FB",
                });
                this.$router.push({ name: "verifyPhoneCode", params: { phoneNo: this.userInfo.phoneNo } });
            });
        },
    },
};
</script>

<style lang="less" scoped>
.comfirm-btn {
    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
}
.verifyPhone {
    min-height: 100vh;
    background-color: #fff;
    padding: 80px 24px 0;
    .verifyPhone-img {
        width: 408px;
        height: 274px;
    }
    .verifyPhone-phoneNumber {
        font-size: 60px;
        font-weight: 500;
        color: #333333;
        margin: 80px 0 39px;
    }
    .verifyPhone-getCode-btn {
        margin-top: 112px;
    }
}
</style>
